import React from 'react';
import StyledSection from '../styles/StyledSection';
import { StyledHeading } from '../styles/styles';

interface InvestmentEntitySelectionWrapperProps {
  heading?: string;
  children?: React.ReactNode;
}

const InvestmentEntitySelectionWrapper: React.FC<InvestmentEntitySelectionWrapperProps> = ({
  children,
  heading,
}) => {
  return (
    <StyledSection
      tone="tone2"
      sx={{
        py: '0.5rem',
        px: '1rem',
        mb: 3,
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        lineHeight: 1,
      }}
    >
      {heading && (
        <StyledHeading noTopPadding headerVariant="subheading" reduceBottomPadding>
          {heading}
        </StyledHeading>
      )}

      {children}
    </StyledSection>
  );
};

export default InvestmentEntitySelectionWrapper;
